;(function() {
  'use strict'

  imagePicker.$inject = ["glDialog"];
  angular.module('core.imagePicker').directive('imagePicker', imagePicker)

  /* @ngInject */
  function imagePicker(glDialog) {
    var acceptedImageTypes = [
      'image/bmp',
      'image/gif',
      'image/jpg',
      'image/jpeg',
      'image/png',
      'image/svg+xml',
    ]

    return {
      restrict: 'E',
      scope: {
        model: '=',
        onImage: '&',
      },
      templateUrl: 'image-picker.template.html',
      link: link,
    }

    function link(scope, elem) {
      var file
      var fr
      var input

      input = angular.element(angular.element(elem)[0].querySelector('input'))
      input.bind('change', onChange)

      function onChange(e) {
        fr = new FileReader()
        file = e.target.files[0]

        var validType = _.includes(acceptedImageTypes, file.type)

        fr.onloadend = function() {
          scope.$apply(function() {
            scope.model = fr.result

            if (scope.onImage) {
              scope.onImage({ $image: fr.result })
            }
          })
        }

        if (!validType) {
          glDialog.alert(
            'Invalid Image',
            'Please check to make sure your picture is either `png` or `jpeg` format.'
          )
          input.val(null)
          return
        }
        if (file) {
          fr.readAsDataURL(file)
        }
      }
    }
  }
})()
